import { useEffect, useRef, useState } from 'react'
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  SelectChangeEvent,
  FormHelperText,
  InputAdornment,
  Typography,
} from '@mui/material'

import { useStyles } from './../styles'

export interface Option {
  id: string
  name?: string
  text: string
}

interface IProps {
  label?: string
  options: Option[]
  selected: string[]
  onChange: (selectedIds: string[]) => void
  helperText?: string
  disabled?: boolean
}

export const ApproveFeedbacksSelect = ({
  label,
  options,
  selected,
  onChange,
  helperText,
  disabled = false,
}: IProps) => {
  const classes = useStyles()

  // Create a ref to the select component
  const [open, setOpen] = useState(false)
  const selectRef = useRef<HTMLSelectElement>(null)

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value as string[]
    onChange(value)
  }

  const renderValue = (selectedIds: string[]) => {
    if (selectedIds.length === options.length) {
      return 'ALL'
    }
    return selectedIds.map((id) => options.find((opt) => opt.id === id)?.name || id).join(', ')
  }

  // Handle label click to open the select dropdown
  const handleLabelClick = () => {
    if (selectRef.current) {
      // Trigger focus or click to open the dropdown
      selectRef.current.click()
    }
  }

  return (
    <FormControl disabled={disabled} className={classes.selectionOptionsFormControl}>
      <Select
        ref={selectRef} // Attach the ref to the Select component
        className={classes.formSelect}
        multiple
        value={selected}
        onChange={handleChange}
        renderValue={renderValue}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        MenuProps={{
          autoFocus: false,
          PaperProps: {
            className: classes.selectMenu,
          },
        }}
        startAdornment={
          <InputAdornment position="start" onClick={() => setOpen(true)}>
            <Typography className={classes.selectLabel}>{label && label + ':'}</Typography>
          </InputAdornment>
        }
      >
        {options.map((opt) => (
          <MenuItem key={opt.id} value={opt.id} disableGutters>
            <Checkbox size="small" checked={selected.includes(opt.id)} />
            <ListItemText primary={opt.name} />
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}
